
/**
 * The component is used as a placeholder/loader for images inside a `Zammad` ticket article.
 * In the email body, these images come with a relative URL. The current component receives
 * the article and a fragment (chunk) with the image data as input. It implements a function
 * for loading the image through an endpoint, creating a Blob, and rendering this image in
 * place of the placeholder.
 */
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { JobTicketAtricle, JobTicketArticleImageData } from '@/models/jobTicket';
import { getJobTicketAttachment } from '@/api';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    Icon,
  },
})
export default class ZammadTicketCreationForm extends Vue {
  @Prop({ type: Object, required: true }) public article: JobTicketAtricle;
  @Prop({ type: Object, required: true }) public fragment: JobTicketArticleImageData;

  public handleDownloadImageClicked(article: JobTicketAtricle, image) {
    if (this.fragment['image'].loading === true) {
      return;
    }
    this.fragment['image'].loading = true;
    this.$forceUpdate();

    getJobTicketAttachment(article.ticket_id, article.id, image.id)
      .then(response => {
        const format = image.name.split('.')[1];
        const blob = new Blob([response.data], { type: `image/${format || 'jpg'}` });
        const url = window.URL.createObjectURL(blob);
        this.fragment['image'].url = url;
      })
      .catch(() => {
        notifyNetworkError({ title: 'Error downloading the image' });
      })
      .finally(() => {
        this.fragment['image'].loading = false;
        this.$forceUpdate();
      });
  }
}
